export default "assets/images/map_mobile-b5b195bf.jpg";